import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions('master', ['getMasters']),
    ...mapActions('diklat', ['fetch', 'create', 'update', 'getDetail', 'action', 'ajuan', 'batalAjuan']),

    fetchData: function() {
      return new Promise((resolve) => {
        const params = Object.assign({}, this.params, this.$isObject(this.filters) ? this.filters : {});
        const type = this.type;
        this.fetch({ params, type }).then(({ data, meta }) => {
          this.data = data || [];
          this.meta = meta || {};
          this.total = meta?.total || 0;
          this.pageTotal = meta?.last_page || 1;
          this.params.limit = meta?.per_page || this.params.limit;
          this.statistik = meta?.statistik || {};
          resolve(true);
        });
      });
    },

    async onEditPengawas(item) {
      const { data } = await this.getDetail({
        type: this.type,
        id: this.$getDeepObj(item, 'psp_diklat_sekolah_id'),
      });
      const init = { detail: data };

      this.formulir = {};
      this.$set(this.formulir, 'id', this.$getDeepObj(item, 'psp_diklat_sekolah_id'));
      this.$set(this.formulir, 'form', 'FormPengawas');
      this.$set(this.formulir, 'mode', 'form');
      this.$set(this.formulir, 'title', `Pilih Pengawas Sekolah`);
      this.$set(this.formulir, 'init', null);
      this.$refs.modal.open();
      this.$nextTick(() => {
        if (this.$refs.formulir) this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', init);
      });
    },

    async onListPeserta(item) {
      this.onEditPeserta(item, true);
    },

    async onEditPeserta(item, preview) {
      const { data, meta } = await this.getDetail({
        type: this.type,
        id: this.$getDeepObj(item, 'psp_diklat_sekolah_id'),
      });
      // const init = {
      //   detail: data,
      //   guru: meta?.guru ?? [],
      //   mapel: meta?.mapel ?? [],
      // };

      this.formulir = {};
      this.$set(this.formulir, 'id', this.$getDeepObj(item, 'psp_diklat_sekolah_id'));
      this.$set(this.formulir, 'form', 'FormInfo');
      this.$set(this.formulir, 'mode', preview ? 'detail' : 'form');
      this.$set(this.formulir, 'title', `${preview ? 'Detail' : 'Ubah'} Guru Sasaran Diklat Sekolah Penggerak`);
      this.$set(this.formulir, 'type', this.type);
      this.$set(this.formulir, 'init', null);
      this.$refs.modal.open();
      this.$nextTick(() => {
        // this.$refs.formulir.reset();
        this.$set(this.formulir, 'meta', meta);
        this.$set(this.formulir, 'detail', data);
        this.$set(this.formulir.detail, 'status', status);
      });
    },

    onSave() {
      const isEdit = this.formulir.isEdit;
      const id = this.formulir.id;
      const params = Object.assign({}, this.$refs.formulir.getValue());
      if (this.formulir.form === 'FormPeserta') {
        this.onSaveDiklat(params);
        return;
      }

      this.action({ params, id, type: this.type, action: 'save-pengawas' })
        .then(({ data }) => {
          this.$success(`Data Pengawas berhasil disimpan`);
          this.$refs.modal.close();
          this.onReload();
          if (!isEdit && !this.formulir.isExist) {
            this.resetAkun(this.$getDeepObj(data, 'id'));
          }
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onSaveDiklat(params) {
      const payload = { diklat_gurus: params };
      this.action({ type: this.type, id: this.formulir.id, action: 'save', params: payload })
        .then(() => {
          this.$success(`Ubah Guru Sasaran Diklat Sekolah Penggerak berhasil disimpan`);
          this.onReload();
          this.$refs.modal.close();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    filterStatus(filters) {
      // set filter
      this.filters = filters;
      Object.assign(this.params, { page: 1 });
      this.onReload();
      this.$refs.filter.close();
    },

    onDeletePengawas(item) {
      const id = this.$getDeepObj(item, 'psp_diklat_sekolah_id');
      this.$confirm(
        `Anda yakin ingin menghapus data Pengawas dari sekolah 
          <strong>${this.$getDeepObj(item, 'sekolah.data.nama') || '-'}</strong> 
         ?`,
        `Hapus Pengawas Sekolah`,
        {
          tipe: 'error',
        }
      ).then(() => {
        this.action({ id, type: this.type, action: 'delete-pengawas' }).then(() => {
          this.$success('Data Pengawas Berhasil dihapus');
          this.onReload();
        });
      });
    },

    onAjuan(data) {
      if (this.tutupPendaftaran && this.kVerval !== 5) {
        const msg = `<b>Ajuan Peserta Diklat</b> Program Sekolah Penggerak telah berakhir`;
        this.$error(msg);
        return;
      }

      const id = data.psp_diklat_sekolah_id;
      const type = this.type;
      const message = '<h3>Anda yakin ingin mengajukan Peserta untuk Sekolah berikut?</h3>' + this.getMessage(data);

      this.$confirm(message, `Ajuan Peserta Diklat`, {
        tipe: 'success',
      }).then(() => {
        this.ajuan({ id, type }).then(() => {
          this.$success(`Data Peserta Diklat berhasil diajukan`);
          this.onReload();
        });
      });
    },

    onBatalAjuan(data) {
      if (this.tutupPendaftaran) {
        const msg = `<b>Ajuan Peserta Diklat</b> Program Sekolah Penggerak telah berakhir`;
        this.$error(msg);
        return;
      }

      const id = data.psp_diklat_sekolah_id;
      const type = this.type;
      const message =
        '<h3>Anda yakin ingin membatalkan pengajuan Peserta untuk Sekolah berikut?</h3>' + this.getMessage(data);

      this.$confirm(message, `Batal Ajuan Peserta Diklat`, {
        tipe: 'error',
      }).then(() => {
        this.batalAjuan({ id, type }).then(() => {
          this.$success(`Ajuan Anda berhasil dibatalkan`);
          this.onReload();
        });
      });
    },

    onInfoAjuan(item) {
      const type = this.type;
      const id = this.$getDeepObj(item, 'psp_diklat_sekolah_id');

      this.formulir = {};
      this.getDetail({ type, id }).then(({ data, meta }) => {
        this.$set(this.formulir, 'mode', 'detail');
        this.$set(this.formulir, 'form', 'FormInfo');
        this.$set(this.formulir, 'title', 'Info Ajuan peserta Diklat');

        this.$refs.modal.open();
        this.$nextTick(() => {
          this.$set(this.formulir, 'meta', meta);
          this.$set(this.formulir, 'detail', data);
        });
      });
    },

    isLengkapAjuan(data) {
      return (
        this.$getDeepObj(data, 'psp_diklat_pengawases.data.0.ptk.data.nama') &&
        this.$getDeepObj(data, 'jml_guru_diklat')
      );
    },

    getMessage(data) {
      return [
        '<div class="pa-3 grey lighten-3 v-list-item theme--light mt-2">',
        '<div class="v-list-item__content py-0">',
        `<h2 class="subtitle-1 black--text">${this.$getDeepObj(data, 'sekolah.data.nama' || '-')}</h2>`,
        '<div class="row no-gutters">',
        '<div class="col-md-4 col-12">',
        '<span class="caption">Kepala Sekolah</span>',
        `<p class="ma-0">${this.$getDeepObj(data, 'ptk_kasek.data.nama') || '-'}</p>`,
        '</div>',
        '<div class="col-md-4 col-12">',
        '<span class="caption">Pengawas</span>',
        `<p class="ma-0">${this.$getDeepObj(data, 'psp_diklat_pengawases.data.0.ptk.data.nama') || '-'}</p>`,
        '</div>',
        '<div class="col-md-4 col-12">',
        '<span class="caption">Jumlah Peserta</span>',
        `<p class="ma-0">${this.$getDeepObj(data, 'jml_guru_diklat') || 0} Guru</p>`,
        '</div>',
        '</div>',
        '</div>',
        '</div>',
      ].join('');
    },
  },
};
